<template>
  <div style="overflow-y: auto;">
        <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-large
        rounded="sm"
        style="height:100vh"
        variant="dark"
        id="loader"
      >
      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Mobile Number Update</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">Mobile Number Update</span>
          </b-col>
        </b-row>
        <hr/>
        <div style="padding-left:30px;  ">

          <b-row style="padding-top: 10px;">
                <b-col col cols="12" sm="3" md="3" lg="2" style="padding-top: 7px;">
                      <span style="font-weight:600" >Consumer No <span class="text-danger">*</span></span>
                </b-col>
                <b-col col cols="6" sm="3" md="8" lg="4">
                    <b-form-input type="text" maxlength="12" value="" id="consumerNumber" placeholder="Enter your Consumer Number" autocomplete="off" trim required />
                </b-col>
                <b-col col cols="4" sm="3" md="3" lg="1">
                    <b-button @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                      <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                    </b-button>
                </b-col>
              </b-row>
        <br>
      <!-- </form> -->

      <div id="UserDetails" class="userDetails marginRight30px" >
        <b-row>
          <b-col cols=12>
              <span class="heading">User Details</span>
          </b-col>
        </b-row>
        <hr/>
        <br>
        <!-- <form id="userRegistration"> -->
          <b-row>
            <b-col col cols="5" sm="2" md="2" lg="2">
                <span class="label">Consumer Name : </span>
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
              <span id="consName" ></span>
              </b-col>

            <b-col col cols="5" sm="2" md="2" lg="2" class="marginTop10px">
              <span class="label">Connection Type : </span>
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
              <span id="connType" ></span>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col col cols="5" sm="2" md="2" lg="2">
                Mobile No <span class="text-danger">*</span> :
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
                <b-form-input type="number"  id="mobNo"   placeholder="Enter Mobile No" trim >
                </b-form-input>
<!--
              <span>
                <a @click="changeMobileNo()" style="color: #e64a19;cursor:pointer "
                  onmouseover="this.style.textDecoration='underline'; this.style.color='blue';"
                  onmouseout="this.style.textDecoration='none'; this.style.color='#e64a19 ';">
                  Change Mobile No
                </a>
              </span> -->
            </b-col>
            <b-col col cols="5" sm="2" md="2" lg="2">
               Email ID </span> :
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
              <b-form-input type="email" id="email"  placeholder="Enter Email ID " trim  >
               </b-form-input>
            </b-col>

          </b-row>
<br>
          <b-row>
            <b-col col cols="5" sm="2" md="2" lg="2">
                Occupation <span class="text-danger">*</span> :
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
              <b-form-select id="occupation" class="mb-3" v-model="selected">
                 <b-form-select-option value="null" >Please select an option</b-form-select-option>
                 <b-form-select-option value="Govt">Govt Employee</b-form-select-option>
                 <b-form-select-option value="SemiGovt">Semi Govt Employee</b-form-select-option>
                 <b-form-select-option value="PSU">PSU Employee</b-form-select-option>
                 <b-form-select-option value="Others">Others</b-form-select-option>
               </b-form-select>
            </b-col>
            <b-col col cols="5" sm="2" md="2" lg="2">
               Aadhaar No </span> :
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
              <b-form-input type="text" maxlength="12" id="aadhaar"  placeholder="" trim  >
               </b-form-input>
            </b-col>

          </b-row>
          <br>
          <br>
          <b-row>
            <b-col col cols="12" sm="3" md="3" lg="3" offset-md="4" offset-lg="4">
                <b-button block squared variant="primary"  id="button"  @click="sendOtp()">
                  Submit</b-button>
                 <br>
            </b-col>
          </b-row>
        <!-- </form> -->
      </div>

      </div>
  </b-container>
  <br>


  <b-modal id="otpModal" centered no-close-on-esc  no-close-on-backdrop title="OTP Verification" hide-footer>
    <b-overlay
    :show="show1"
    spinner-variant="primary"
    spinner-large
    rounded="sm"
    style=""
    variant="dark"
    id="loader"
  >
    Enter the OTP received in your mobile number :
    <b-form-input type="number" id="otp" ></b-form-input><br>
    <b-button class="btn" variant="primary" id="success-btn" @click="mobileUpdate()" >Verify</b-button> &nbsp&nbsp
    <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()" >Resend OTP</b-button>
</b-overlay>
  </b-modal>

  <b-modal id="successModal" centered no-close-on-esc no-close-on-backdrop scrollable  hide-footer hide-header>
    <h3>Consumer Mobile No Update</h3>
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
    </svg>
    <p class="success">Successfully Updated !<br><br>
    <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage()" >OK</b-button>
    </p>
  </b-modal>

  <b-modal id="failureModal" centered lazy scrollable title="Consumer Mobile No Update" hide-footer>
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
    </svg>
    <p class="error">Update Failed ! </p>

  </b-modal>

  <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
    <span class="data" id="modalMsg"> DEMO </span>
    <br><br>
      <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
  </b-modal>
</b-overlay>
  </div>

</template>


<script>
import axios from 'axios';
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
var CryptoJS = require("crypto-js");
var consNo= "";
var oldMob="";
var email ="";
var aadhaar ="";
var occupation="";
var encAdhar="";
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
export default {
  name: 'ConsReg',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
        value: '',
        show: false,
        show1: false,
        show2 : false,
        consNumber: "",
        selected: null
    }
  },
  methods: {
    reloadPage()
    {
      window.location.reload();
    },

    showDetails() {
      consNo= document.getElementById("consumerNumber").value;
      this.consNumber=consNo;
      // alert(consNo)
      // document.getElementById('consNo').innerHTML = consNo;
      if(consNo=="")
        {
          // document.getElementById('failure-btn-mob').click();
          this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          document.getElementById("mobNo").focus();
         return;
        }
      var parent=this;
      this.show= true;
    //  axios.post('http://192.168.88.222:8080/cbs/RestAPI/myBijulee/ConsDetails?cons_no='+consNo)
     axios.post(this.$urlArms+'/RestAPI/myBijulee/ConsDetails?cons_no='+consNo)
        .then((response) => {
        parent.show= false;
        document.getElementById("UserDetails").classList.add("showUserDetails");

        console.log(response.data);
        var data=response.data;
        var status = data.message;

        if(status=="00")
        {
          document.getElementById("consName").innerHTML = data.cons_name;
          document.getElementById("connType").innerHTML = data.connType;
          document.getElementById("mobNo").value = data.mobile_no;
          oldMob = data.mobile_no;
          email = data.email
          document.getElementById("email").value = data.email;
          parent.selected = data.occupation;
          console.log("adhar no::::"+data.aadhar_NO);
          if (data.aadhar_NO== null || data.aadhar_NO=="")
          document.getElementById("aadhaar").placeholder = "Enter Aadhar No";
          else
          document.getElementById("aadhaar").placeholder = "UPDATED";
        }
        else
        {
          parent.show= false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Sorry, Consumer Not Found";
          document.getElementById("UserDetails").classList.remove("showUserDetails");
        }

      })
      .catch((e) => {
      console.log("Caught", e);
      this.show= false;
    })

  },
changeMobileNo()
{
    document.getElementById("mobNo").value="";
    document.getElementById("mobNo").focus();
},
sendOtp()
{
  var parent =this;
  var mobile = document.getElementById("mobNo").value;
  occupation = document.getElementById("occupation").value;
  email = document.getElementById("email").value;
  aadhaar = document.getElementById("aadhaar").value;
  encAdhar = CryptoJS.AES.encrypt(aadhaar, "U@M@A&N#G$-A#P%d&u@c-h1_e@r$r%l#");

//  encAdhar = this.encryptAadhar(aadhaar.trim());
  console.log("Aadhaar : "+aadhaar)
  //console.log("Encrypted Aadhaar : "+encAdhar)
  // if(oldMob == mobile && occupation !="null")
  // {
  //   console.log("same");
  //   this.$bvModal.show('successModal');
  //   return;
  // }

  var mobregx = /^[5-9]\d{9}$/
  if(!mobregx.test(mobile))
    {
      // document.getElementById('failure-btn-mob').click();
      this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
        title: `Alert`,
        variant: 'danger',
        solid: true
      })
      document.getElementById("mobNo").focus();
    return
    }


    var emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if(!emailRegex.test(email) && email!="")
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter Valid Email !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("email").focus();
      return
      }



    if(occupation=="null")
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Please Select Your Occupation !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
          document.getElementById("occupation").focus();
      return
      }
      var aadhaarRegex =  /^\d{12}$/;
      if(!aadhaarRegex.test(aadhaar) && aadhaar!="")
        {
          // document.getElementById('failure-btn-mob').click();
          this.$bvToast.toast('Enter Valid 12 digit Adhaar Number !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          document.getElementById("aadhaar").focus();
        return
        }

 parent.show= true;
  axios.post(this.$urlCommon+"/api/generateOtp?mobNo="+mobile).then(function(response) {
    console.log(response.data);
    parent.show= false;
    if (response.data.message == "success") {
      parent.$bvToast.toast('OTP Sent Successfully !', {
        title: `Success`,
        variant: 'success',
        solid: true
      });
      parent.$bvModal.show('otpModal');

    }
  });

},

closeModal(){
  this.$bvModal.hide('model')
},
resendOtp()
{
  var parent =this;
  var mobile = document.getElementById("mobNo").value;
  parent.show1= true;
  axios.post(this.$urlCommon+"/api/reGenerateOtp?mobNo="+mobile).then(function(response) {
    parent.show1= false;
    if (response.data.message == "success") {
      parent.$bvToast.toast('OTP Sent Successfully !', {
        title: `Success`,
        variant: 'success',
        solid: true
      });
    }
  else {
      parent.$bvToast.toast('OTP Could not Sent !', {
        title: `danger`,
        variant: 'danger',
        solid: true
      });
    }
  });
},

mobileUpdate(){
      var otp = document.getElementById("otp").value;
      var mobile = document.getElementById("mobNo").value;

    var parent=this;

console.log(mobile+":::"+oldMob+":::"+email+":::"+consNo+"::::"+aadhaar+":::"+occupation);
var mobregx = /^[5-9]\d{9}$/
if(!mobregx.test(mobile))
  {
    // document.getElementById('failure-btn-mob').click();
    this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
      title: `Alert`,
      variant: 'danger',
      solid: true
    })
  return
  }


     if(otp=="")
        {
          // document.getElementById('failure-btn-mob').click();
          this.$bvToast.toast('Enter OTP !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
        return
        }
      parent.show1= true;
      axios.post(this.$urlCommon+"/api/validateOtp?mobNo="+mobile+"&otpNo="+otp).then(function(response) {

        if (response.data.message == "VALID") {

            parent.$bvToast.toast('OTP Successfully Verified !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });

          axios.post(parent.$urlCommon+"/myBijulee/updateConsumerDetails?consNo="+consNo+"&mobNo="+mobile+"&email="+email).then(function(response) {
          console.log(response.data);
         var parent2= parent;
          var msg=response.data.msg;
          if(msg=="00" || msg=="01" )
           {
            var data = encAdhar.toString();
              var config = {
                method: 'post',
                url: parent2.$urlArms+'/RestAPI/website/armsConsDetailsUpdate?mobNo='+mobile+'&email='+email+'&occupation='+occupation+'&consNo='+consNo+'',
                headers: {
                  'Content-Type': 'text/plain'
                },
                data : data
              };
              axios(config)
              .then(function (response) {
                parent.show1= false;
                parent.show= false;
                console.log(JSON.stringify(response.data));
                var msg1=response.data.msg;
                  if(msg1=="success")
                  {
                    parent.$bvModal.hide('modalChangeNo');
                    parent.$bvModal.show('successModal');
                  }
                  else {
                    parent.$bvModal.hide('modalChangeNo');
                    parent.$bvModal.show('failureModal');
                  }

              })
              .catch(function (error) {
                console.log(error);
              });


          }
          else
          {
          parent.$bvModal.hide('modalChangeNo');
          parent.$bvModal.show('failureModal');
          }
          })
          .catch((e) => {
            parent.show= false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
            console.log("Caught :::::::::::::::", e.message);
          })



        }
        else{
          parent.show1= false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Invalid OTP";
        }
      });

    },
  encryptAadhar(plaintext){
	    var encryptedAES = CryptoJS.AES.encrypt(plaintext, "U@M@A&N#G$-A#P%d&u@c-h1_e@r$r%l#");
	    console.log("ct: " + encryptedAES);
	    return encryptedAES;
    }
  }
}
</script>

<style scoped="true">
.label{

}
.data{
  font-weight: 500;
  color: #e64a19      ;
  font-size: 1.1rem;
}
.userDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
}
.showUserDetails
{
 visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.modalFont{
  width: 100px;
  display: block;
  margin: 40px auto 0;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}
p.success {
  color: #73AF55;
}
p.error {
  color: #D06079;
}
.hideDiv
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

    padding: 0rem;
}
.showDiv
{
 visibility: visible;
 opacity: 1;
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }
  @media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .marginRight30px{
      margin-right: 30px !important;
    }
  }
  @media (max-width: 576px) {
    .marginTop10px{
      margin-top: 10px !important;
    }
  }

</style>
